import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../Utils/renderField/renderReadField";
import "./MetricasPaletizacion.css";
import { formatDisplayNumber } from "../../../../../../../utility/utils";

const TooltipPortal = ({ visible, top, left, children }) => {
    if (!visible) {
        return null;
    }

    return ReactDOM.createPortal(
        <div
            style={{
                position: "fixed",
                top,
                left,
                zIndex: 999999,
            }}
        >
            {children}
        </div>,
        document.body,
    );
};

export const ResumenProductosMetrica = ({
    id,
    tooltipActivo,
    setTooltipActivo,
    productos,
    tipo,
    titulo,
}) => {
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);
    const hideTimeoutRef = useRef(null);

    const [tooltip, setTooltip] = useState({
        top: 0,
        left: 0,
        hoverTooltip: false,
    });

    useEffect(() => {
        const handleScroll = function (event) {
            let node = event.target;

            while (node) {
                if (node.dataset && node.dataset.tooltipScroll === "true") {
                    return;
                }

                node = node.parentNode;
            }

            setTooltipActivo(null);
        };

        window.addEventListener("scroll", handleScroll, true);

        return function () {
            window.removeEventListener("scroll", handleScroll, true);
        };

        return () => {
            clearTimeout(hideTimeoutRef.current);
        };
    }, []);

    // se incluye por peso además de por pacas: el sobrante puede tener saldo
    // en kg sin completar una paca (pacas = 0) y aun así debe mostrarse
    const productosConPacas = (productos || []).filter(function (p) {
        return (
            p[tipo] && (Number(p[tipo].pacas) > 0 || Number(p[tipo].peso) > 0)
        );
    });

    if (!productosConPacas.length) {
        return null;
    }

    const mostrarTooltip = function () {
        clearTimeout(hideTimeoutRef.current);

        if (!triggerRef.current) {
            return;
        }

        const rect = triggerRef.current.getBoundingClientRect();

        const tooltipWidth = 450;
        const height =
            tooltipRef.current && tooltipRef.current.offsetHeight
                ? tooltipRef.current.offsetHeight
                : 300;
        // const tooltipHeight = window.innerHeight * 0.6;
        const tooltipHeight = height;

        let left = rect.left;
        let top = rect.bottom + 8;

        // Si se sale por la derecha, mover a la izquierda
        if (left + tooltipWidth > window.innerWidth) {
            left = window.innerWidth - tooltipWidth - 10;
        }

        if (left < 10) {
            left = 10;
        }

        // Si no cabe abajo, mostrar arriba
        if (top + tooltipHeight > window.innerHeight) {
            top = rect.top - tooltipHeight + 150;
        }

        if (top < 10) {
            top = 10;
        }

        setTooltip(function (prev) {
            return {
                ...prev,
                top,
                left,
            };
        });

        setTooltipActivo(id);
    };

    const ocultarTooltip = function () {
        hideTimeoutRef.current = setTimeout(function () {
            setTooltip(function (prev) {
                if (prev.hoverTooltip) {
                    return prev;
                }

                return {
                    ...prev,
                    hoverTooltip: false,
                };
            });

            setTooltipActivo(function (actual) {
                return actual === id ? null : actual;
            });
        }, 150);
    };

    const visible = tooltipActivo === id;

    return (
        <React.Fragment>
            <div
                ref={triggerRef}
                style={{ cursor: "help" }}
                onMouseEnter={mostrarTooltip}
                onMouseLeave={ocultarTooltip}
            >
                <span
                    className="text-muted"
                    style={{
                        maxWidth: "230px",
                        display: "block",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                    }}
                >
                    {productosConPacas
                        .map(function (p) {
                            return (
                                p.producto_nombre +
                                " (" +
                                formatDisplayNumber(p[tipo].pacas) +
                                ")"
                            );
                        })
                        .join(", ")}
                </span>
            </div>

            <TooltipPortal
                visible={visible}
                top={tooltip.top}
                left={tooltip.left}
            >
                <div
                    ref={tooltipRef}
                    className="tooltip-productos"
                    onMouseEnter={function () {
                        clearTimeout(hideTimeoutRef.current);

                        setTooltip(function (prev) {
                            return {
                                ...prev,
                                hoverTooltip: true,
                            };
                        });
                    }}
                    onMouseLeave={function () {
                        setTooltip(function (prev) {
                            return {
                                ...prev,
                                hoverTooltip: false,
                            };
                        });

                        setTooltipActivo(null);
                    }}
                >
                    <h6 className="mb-2">{titulo}</h6>

                    <div
                        className="new-table-wrapper"
                        data-tooltip-scroll="true"
                    >
                        <table>
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th>Pacas</th>
                                    <th>Peso</th>
                                </tr>
                            </thead>

                            <tbody>
                                {productosConPacas.map(function (p, index) {
                                    return (
                                        <tr
                                            key={
                                                p.producto_id +
                                                "-" +
                                                tipo +
                                                "-" +
                                                index
                                            }
                                        >
                                            <td className="text-center">
                                                {p.producto_nombre}
                                            </td>

                                            <td className="text-center">
                                                <RenderNumber
                                                    value={p[tipo].pacas}
                                                />
                                            </td>

                                            <td className="text-center">
                                                <RenderKilogramo
                                                    value={p[tipo].peso}
                                                    decimals={3}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </TooltipPortal>
        </React.Fragment>
    );
};
